export default __webpack_public_path__ + "static/media/445.71dde5c1.png";